/** Query-key root for raw-footage asset inventories. */
export const RAW_FOOTAGE_KEY = 'raw-footage' as const;

/** Asset metadata changes rarely relative to a browse session. */
export const RAW_FOOTAGE_STALE_TIME = 5 * 60_000;

/** Default page size for project asset listings. */
export const PROJECT_ASSETS_PAGE_SIZE = 50;
